import React,{useEffect,useState} from 'react'
import {useSelector,useDispatch} from 'react-redux'
import firebase from '../../firebase'
import './dashboard.css'
import {
    Button,
    notification,
    Divider
} from 'antd'
import Spinner from '../common/Spinner'
import ProfileDrawer from './ProfileDrawer'
import Navbar from './Navbar'
import Rewards from './Menu/Rewards'
import Main from './Main'
import Footer from '../landing/Footer'

export default function Dashboard() {
    const dispatch = useDispatch();
    const auth = useSelector(state=>state.auth)
    const user = useSelector(state=>state.user)
    var [profileVisible,setProfileVisible] = useState(false)
    var [title,setTitle] = useState("DASHBOARD")
   
        
    return (
        <div>
        {!auth.isAuth && !user ? 
            <Spinner/>
            :
        <div id="dashboard">
    
            <Navbar title={title}  setProfileVisible={setProfileVisible}/>
            
            <div id="main">
                <Main/>
                <Rewards />
            </div>
            <Divider/>
            <Footer/>
            <ProfileDrawer profileVisible={profileVisible} setProfileVisible={setProfileVisible}/>
        </div>
    }
      </div>  
    )
}
